const auto_upgrade_options_list = [
  {
    config: "1",
    value: "1",
    label: "r_enable",
    id: "auto_agree",
  },
  {
    config: "0",
    value: "0",
    label: "r_disable",
    id: "auto_disagree",
  },
];

export const upgrade = {
  auto_upgrade_enable: auto_upgrade_options_list,
};

export default upgrade;
